import React from "react";
import { Layout } from "../../layouts/Layout";
import { BlogPageWrapper } from "../../components/BlogAreas/BlogPageWrapper";
import { Link } from "react-router-dom";
import {
  BLOG_AVATAR01,
  BLOG_DETAILS01,
  BLOG_DETAILS02,
  CHECK_ICON,
} from "../../lib/assets";
import { VideoPlayerOne } from "../../components/VideoPlayers/VideoPlayerOne";
import { BlogAuthorInfo } from "../../components/BlogAreas/BlogAuthorInfo";
import { BlogComments } from "../../components/BlogAreas/BlogComments";
import { BlogCommentForm } from "../../components/BlogAreas/BlogCommentForm";

const BlogDetailsPage = () => {
  return (
    <Layout footer ={2} breadcrumb={"Blog Details"} title={"Key Trends"}>
      <BlogPageWrapper>
        {/* image and project info side by side */}
     {/*   <div className="row">
          <div className="col-md-8">
            <div className="blog-details-thumb">
              <img src={BLOG_DETAILS01} alt="" style={{width:"807px", height:"371px", paddingLeft:"20px", borderRadius:"50%"}}/>
            </div>
          </div>

          <div className="col-md-4" p-10>
            <div className="project-details-info">
              <h4 className="title">Project Information</h4>
              <ul className="list-wrap">
                <li>
                  <span>Client:</span>Client Name
                </li>
                <li>
                  <span>Date:</span>22 Jan, 2024
                </li>
             
                <li>
                  <span>Author:</span> Nithin
                </li>
                <li>
                  <span>Place:</span>Chennai
                </li>
                <li className="social">
                  <span>Share:</span>
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                            <i className="fab fa-linkedin"></i>
                                              </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
*/}
        {/* content */}
        <div className="blog-details-content">
          <h2 className="title">5 Key Trends Shaping the Future of Business: Insights for Leaders</h2>

          <div className="blog-meta-three">
            <ul className="list-wrap">
              <li>
                <i className="far fa-calendar"></i>22 Jan, 2024
              </li>
              <li>
                <img src={BLOG_AVATAR01} alt="" />
                by <Link to="/blog-details">Nithin Krishna</Link>
              </li>
              <li>
                <i className="fas fa-tags"></i>
                <Link to="/blog">Leadership,</Link>
                <Link to="/blog">Business</Link>
              </li>
            </ul>
          </div>

          <p>
            In the ever-evolving world of business, staying ahead of trends is critical for leaders
            to maintain a competitive edge. As we navigate a landscape defined by rapid technological
            advancements, shifting consumer behaviors, and global challenges, these five key trends
            are shaping the future of business and setting the stage for a transformative era.
          </p>
          <p>
            Whether it's leveraging cutting-edge technology, embracing sustainable practices,
            or redefining the workplace, staying ahead of the curve is essential for sustained success.
            This article explores the five transformative trends shaping the future of business
            and offers actionable insights for leaders to navigate this dynamic landscape.
          </p>
          <blockquote>
            <p>
              “ The future of business isn’t just about survival—it’s
              about shaping the next era of innovation, sustainability, and growth. ”
            </p>
          </blockquote>
          <h4 className="title-two">The Five trends</h4>
          <p>
            Below are the five transformative trends shaping the future of business
          </p>

          <div className="bd-inner-wrap">
            <div className="row align-items-center">
              <div className="col-46">
                <div className="thumb">
                  <img src={BLOG_DETAILS02} alt="" style={{width:"372px", height:"282px"}}/>

                {/*  <VideoPlayerOne
                    src={"https://www.youtube.com/watch?v=6mkoGSqTqFI"}
                  />*/}
                </div>
              </div>

              <div className="col-54">
                <div className="content">
                  <ul className="list-wrap">
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Digital Transformation: The Age of Intelligent Automation
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Redefining Talent: The Gig Economy and Upskilling
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      The Rise of Hybrid Work Models
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Sustainability and Environmental Responsibility
                    </li>
                    <li>
                      <img src={CHECK_ICON} alt="" />
                      Customer-Centric Innovation
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <p>
            These trends highlight the intersection of technology, sustainability,
            and human-centric approaches in shaping the future of business.
            Leaders who proactively embrace these changes will not only remain competitive
            but will also drive meaningful impact in their industries.
          </p>

          <div className="bd-content-bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="post-tags">
                  <h5 className="title">Tags:</h5>
                  <ul className="list-wrap">
                    <li>
                      <a href="#">Trends</a>
                    </li>
                    <li>
                      <a href="#">Leadership</a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* bottom */}
              <div className="col-md-5">
                <div className="blog-post-share">
                  <h5 className="title">Share:</h5>
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                      <i className="fab fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* author info */}
        {/* <BlogAuthorInfo /> */}

        {/* comments */}
        {/* <BlogComments /> */}

        {/* comment form */}
        {/* <BlogCommentForm /> */}
      </BlogPageWrapper>
    </Layout>
  );
};

export default BlogDetailsPage;
